import React, { useEffect } from 'react';
import { useSite } from '../../context/SiteContext';

const DEPT_NAMES = {
  'kinh-doanh': 'Kinh doanh',
  'marketing': 'Marketing',
  'hcns': 'Hành chính - Nhân sự',
  'ke-toan': 'Kế toán',
  'kho-van': 'Kho vận',
  'thu-mua': 'Thu mua',
  'chuyen-mon': 'Chuyên môn'
};

export default function JdModal({ job, isOpen, onClose, onApply }) {
  const { settings } = useSite();

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.body.classList.add('job-modal-open');
      window.addEventListener('keydown', handleKeyDown);
    } else {
      document.body.classList.remove('job-modal-open');
    }
    return () => {
      document.body.classList.remove('job-modal-open');
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen || !job) return null;

  const departmentLabel = DEPT_NAMES[job.department] || job.department || 'Tuyển dụng';
  const objectives = Array.isArray(job.objectives) ? job.objectives : [];
  const responsibilities = Array.isArray(job.responsibilities) ? job.responsibilities : [];
  const requirements = Array.isArray(job.requirements) ? job.requirements : [];
  const benefits = Array.isArray(job.benefits) ? job.benefits : [];

  return (
    <div className="job-modal" role="dialog" aria-modal="true">
      <div className="job-modal__backdrop" onClick={onClose} />
      <div className="job-modal__panel" role="document">
        <button type="button" className="job-modal__close" onClick={onClose} aria-label="Đóng">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </button>

        <div className="job-modal__body">
          <span className="eyebrow">{departmentLabel}</span>
          <h2 id="jobModalTitle">
            {job.title}
            {job.headcount > 0 && (
              <span className="job-modal__count"> · Tuyển {job.headcount} nhân sự</span>
            )}
          </h2>

          {objectives.length > 0 && (
            <>
              <h4>Mục tiêu công việc</h4>
              {objectives.length === 1 ? (
                <p className="lead">{objectives[0]}</p>
              ) : (
                <ul className="pod-list">
                  {objectives.map((obj, i) => (
                    <li key={i}>{obj}</li>
                  ))}
                </ul>
              )}
            </>
          )}

          {responsibilities.length > 0 && (
            <>
              <h4>Mô tả công việc</h4>
              <ul className="pod-list">
                {responsibilities.map((resp, i) => (
                  <li key={i}>{resp}</li>
                ))}
              </ul>
            </>
          )}

          {requirements.length > 0 && (
            <>
              <h4>Yêu cầu công việc</h4>
              <ul className="pod-list">
                {requirements.map((req, i) => (
                  <li key={i}>{req}</li>
                ))}
              </ul>
            </>
          )}

          {job.salary && (
            <>
              <h4>Thu nhập</h4>
              <p className="job-modal__salary">
                <strong>{job.salary}</strong>
              </p>
            </>
          )}

          {benefits.length > 0 && (
            <>
              <h4>Quyền lợi</h4>
              <ul className="pod-list">
                {benefits.map((ben, i) => (
                  <li key={i}>{ben}</li>
                ))}
              </ul>
            </>
          )}

          <h4>Liên hệ ứng tuyển</h4>
          <ul className="pod-list">
            <li>
              <strong>Email:</strong>{' '}
              <a href={`mailto:${settings.jobs_default_email || settings.contact_email}`}>
                {settings.jobs_default_email || settings.contact_email}
              </a>
            </li>
            <li>
              <strong>Hotline/Zalo:</strong> {settings.jobs_default_phone || settings.contact_phone_hr}
            </li>
          </ul>

          <div className="job-modal__actions" style={{ marginTop: '24px' }}>
            <button
              type="button"
              className="btn btn--primary"
              onClick={() => {
                onClose();
                onApply(job);
              }}
            >
              Nộp CV ứng tuyển
              <svg className="arr" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M13 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
